module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row personal-wrapper",
    attrs: {
      "name": "hres8ax"
    }
  }, [_c('component-staappr', {
    attrs: {
      "staappr": _vm.staappr,
      "nowLang": _vm.app.nowLang,
      "detailIndexY": _vm.detailIndex.dteempdb_y,
      "detailIndexM": _vm.detailIndex.dteempdb_m,
      "currentCodempid": _vm.codempid,
      "currentDescCodempid": _vm.descCodempid,
      "currentDteyrepay": _vm.currentDteyrepay
    },
    on: {
      "setCurrentDteyrepay": function($event) {
        _vm.currentDteyrepay = arguments[0]
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.indexDisp),
      expression: "!indexDisp"
    }],
    staticClass: "col-md-12 menu border-bottom-color-skin-dark-10"
  }, [_c('div', {
    staticClass: "panelbutton-mb",
    class: {
      'hidden': _vm.pcDisp
    }
  }, [_c('div', {
    staticClass: "pers-header-btn"
  }, [_c('div', {
    staticClass: "icon-menu fa fa-bars color-skin"
  }), _vm._v(" "), _c('div', {
    staticClass: "label-btn-pers color-skin",
    on: {
      "click": function($event) {
        _vm.toggleMenuMobile()
      }
    }
  }, [_vm._v(" Tax Menu ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cal-panelbutton"
  }, [_c('div', {
    staticClass: "rows clearfix"
  }, [_c('div', {
    staticClass: " box-btn-cal hover btn-width clearfix",
    class: {
      'active color-skin': _vm.totalIncomeYearActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAndSave(1, _vm.currentPage)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-cal"
  }, [_c('img', {
    staticClass: "menu-icon",
    attrs: {
      "src": require("../../assets/img/cal-tax/icon-menu1.png")
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'hidden': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['HRES8AXC1']['90']))]), _vm._v(" "), _c('div', {
    class: {
      'hidden': !_vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['HRES8AXC1']['20']))])])]), _vm._v(" "), _c('div', {
    staticClass: " box-btn-cal hover btn-width clearfix",
    class: {
      'active color-skin': _vm.reduceDunationActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAndSave(2, _vm.currentPage)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-cal"
  }, [_c('img', {
    staticClass: "menu-icon",
    attrs: {
      "src": require("../../assets/img/cal-tax/icon-menu2.png")
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'hidden': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['HRES8AXC2']['80']))]), _vm._v(" "), _c('div', {
    class: {
      'hidden': !_vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['HRES8AXC2']['10']))])])]), _vm._v(" "), _c('div', {
    staticClass: " box-btn-cal hover btn-width clearfix",
    class: {
      'active color-skin': _vm.investmentPlanActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAndSave(3, _vm.currentPage)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-cal"
  }, [_c('img', {
    staticClass: "menu-icon",
    attrs: {
      "src": require("../../assets/img/cal-tax/icon-menu3.png")
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'hidden': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['HRES8AXC3']['120']))]), _vm._v(" "), _c('div', {
    class: {
      'hidden': !_vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['HRES8AXC3']['10']))])])]), _vm._v(" "), _c('div', {
    staticClass: " box-btn-cal hover btn-width clearfix",
    class: {
      'active color-skin': _vm.taxSummaryYearActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAndSave(4, _vm.currentPage)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-cal"
  }, [_c('img', {
    staticClass: "menu-icon",
    attrs: {
      "src": require("../../assets/img/cal-tax/icon-menu4.png")
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'hidden': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['HRES8AXC4']['70']))]), _vm._v(" "), _c('div', {
    class: {
      'hidden': !_vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.app.nowLang]['HRES8AXC4']['10']))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.menuMbDisp) && !_vm.indexDisp),
      expression: "(!menuMbDisp) && !indexDisp"
    }],
    staticClass: "col-md-12 clear-padding"
  }, [_c('v-touch', {
    on: {
      "swipeleft": _vm.onSwipeLeft,
      "swiperight": _vm.onSwipeRight
    }
  }, [_c('hres8ax-salary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalIncomeYearActive),
      expression: "totalIncomeYearActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "detailSalary": _vm.detailSalary
    }
  }), _vm._v(" "), _c('hres8ax-deduction', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reduceDunationActive),
      expression: "reduceDunationActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "detailEvent": _vm.detailEvent,
      "detailDeductionTable1": _vm.columns[_vm.app.nowLang].detailDeductionTable1,
      "detailDeductionTable2": _vm.columns[_vm.app.nowLang].detailDeductionTable2,
      "labels": _vm.labels[_vm.app.nowLang],
      "detailDeduction": _vm.detailDeduction
    }
  }), _vm._v(" "), _c('hres8ax-invest', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investmentPlanActive),
      expression: "investmentPlanActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "detailInvest": _vm.detailInvest
    }
  }), _vm._v(" "), _c('hres8ax-caltax', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.taxSummaryYearActive),
      expression: "taxSummaryYearActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "detailCaltax": _vm.detailCaltax
    }
  })], 1)], 1), _vm._v(" "), _c('input', {
    ref: "popupDetailDeduction",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres8ax-popup-detail-deduction",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('popup-detail-deduction', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "nowLang": _vm.app.nowLang,
      "data": _vm.popupDetailDeduction,
      "detailDeductionSelected": _vm.detailDeductionSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50392304!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres8ax/component.vue
// module id = 3751
// module chunks = 1